import navs from "./nav";

export const publicNavsExceptional = [navs.noAccess()];